import React from 'react';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { useSelector } from 'react-redux';

import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import HelloModal from 'common/components/hello-modal';
import styles from './upgrade-modals.scss';
import HfReactHelper from 'common/utils/hf-react-helper';
import { getFaxRecipientTypes } from './fax-review';

const modalPropMessages = defineMessages({
  title: {
    id: '',
    description: `Title for a modal that tells you to upgrade or use Hellosign to email a document
    to some one from HelloFax`,
    defaultMessage: 'Upgrade or use HelloSign',
  },
  sendInHellosign: {
    id: '',
    description: 'Title for a button that will redirect you to HelloSign to finish your request',
    defaultMessage: 'Send via HelloSign',
  },
  upgrade: {
    id: '',
    description: 'Title for a button that will take you to the pricing page to upgrade your version of HelloFax',
    defaultMessage: 'Upgrade HelloFax',
  },
});

const UpgradeSendEmailModal: types.TriggerComponent = ({ onCancel }) => {
  const intl = useIntl();
  const transmissionGroupGuid = useSelector(selectors.getTransmissionGroupGuid);
  const pricingUrl = HfReactHelper.urlHelper('info/pricing', 'hellofax');
  const bridgeUrl = HfReactHelper.urlHelper(`prep-and-send/send-on-hellosign/${transmissionGroupGuid}`, 'hellofax');

  return (
    <HelloModal
      width='540px'
      scrollable={false}
      isOpen={true}
      onRequestClose={onCancel}
      buttons={[
        { type: 'secondary', text: intl.formatMessage(modalPropMessages.upgrade), buttonLink: pricingUrl, openInNewWindow: true },
        { type: 'primary', text: intl.formatMessage(modalPropMessages.sendInHellosign), buttonLink: bridgeUrl, openInNewWindow: true },
      ]}
      contentLabel={intl.formatMessage(modalPropMessages.title)}
    >
      <span className={styles.upgradeSendBody}>
        <FormattedMessage
          id=""
          description="text for a modal on prep and send that says that emailing signed documents
          is a feature of a different app called Hellosign. They can email the document by either upgrading
          their account, or sending it via Hellosign."
          defaultMessage="Emailing signed documents is a feature of HelloSign. Upgrade your Hellofax account
          or send via HelloSign instead." />
      </span>
    </HelloModal>
  );
};

UpgradeSendEmailModal.needsTrigger = (state, formik) => {
  const workflow = selectors.getWorkflow(state);
  const isPaidAccount = selectors.isPaidAccount(state);
  const recipients = formik.getFieldProps<types.FaxRecipient[]>('recipients');

  const isFaxRequest = workflow.tags.includes(types.WorkflowTags.SignatureRequestFax);

  if (!isFaxRequest || isPaidAccount) {
    return false;
  }

  const { hasEmail } = getFaxRecipientTypes(recipients.value);
  return hasEmail;
};

export default UpgradeSendEmailModal;
